import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineAlert = makeShortcode("InlineAlert");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "tags-apis"
    }}>{`Tags APIs`}</h1>
    <InlineAlert variant="info" slots="text" mdxType="InlineAlert" />
    <p>{`Adobe may add optional request and response members (name/value pairs) to existing API objects at any time and without notice or changes in versioning. Adobe recommends that you refer to the API documentation of any third-party tool you integrate with our APIs so that such additions are ignored in processing if not understood. If implemented properly, such additions are non-breaking changes for your implementation. Adobe will not remove parameters or add required parameters without first providing standard notification through release notes.`}</p>
    <p>{`The CJA Tags APIs allow you to retrieve, update, or create tags and their association with components programmatically through Adobe Developer. The APIs use the same data and methods that are used when working with tags in the UI.`}</p>
    <h2 {...{
      "id": "componentmetadatatags-endpoint-description"
    }}><inlineCode parentName="h2">{`/componentmetadata/tags`}</inlineCode>{` endpoint description`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`/componentmetadata/tags`}</inlineCode>{` endpoint description is shown in our `}<a parentName="p" {...{
        "href": "../../../api.md"
      }}>{`Swagger UI`}</a>{`. Use the Swagger UI to see endpoint summaries, available methods, parameters, example values, models, and status codes, and to try out the API.`}</p>
    <h2 {...{
      "id": "example-creating-tags"
    }}>{`Example creating tags`}</h2>
    <p>{`The following request example includes both a JSON message request body and a `}<inlineCode parentName="p">{`curl`}</inlineCode>{` request to create tags and associate them with existing components.`}</p>
    <h3 {...{
      "id": "json-request-message"
    }}>{`JSON Request Message`}</h3>
    <pre><code parentName="pre" {...{}}>{`[
   {
      "name":"sales",
      "description":"Sales Department",
      "components":[
         {
            "componentType":"project",
            "componentId":"component-id-1"
         },
         {
            "componentType":"segment",
            "componentId":"component-id-2"
         }
      ]
   },
   {
      "name":"marketing",
      "description":"Marketing Department",
      "components":[
         {
            "componentType":"project",
            "componentId":"component-id-101"
         },
         {
            "componentType":"segment",
            "componentId":"component-id-102"
         }
      ]
   }
]
`}</code></pre>
    <p>{`The JSON message requests the following:`}</p>
    <ul>
      <li parentName="ul">{`create two tags with description `}<inlineCode parentName="li">{`Sales Department`}</inlineCode>{` and `}<inlineCode parentName="li">{`Marketing Department`}</inlineCode></li>
      <li parentName="ul">{`associate `}<inlineCode parentName="li">{`Sales Department`}</inlineCode>{` tag with components having ids `}<inlineCode parentName="li">{`component-id-1`}</inlineCode>{` and `}<inlineCode parentName="li">{`component-id-2`}</inlineCode></li>
      <li parentName="ul">{`associate `}<inlineCode parentName="li">{`Marketing Department`}</inlineCode>{` tag with components having ids `}<inlineCode parentName="li">{`component-id-101`}</inlineCode>{` and `}<inlineCode parentName="li">{`component-id-102`}</inlineCode></li>
    </ul>
    <h4 {...{
      "id": "curl-request"
    }}><inlineCode parentName="h4">{`curl`}</inlineCode>{` Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`curl -X POST \\
  https://cja.adobe.io/componentmetadata/tags \\
  -H 'Accept: application/json' \\
  -H 'Authorization: Bearer {ACCESSTOKEN}' \\
  -H 'Content-Type: application/json' \\
  -H 'x-api-key: {API_KEY}' \\
  -H 'x-gw-ims-org-id: {IMS_ORG_ID}' \\
  -d '{REQUESTJSON}'
`}</code></pre>
    <h3 {...{
      "id": "example-response"
    }}>{`Example Response`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
   {
      "id":35632,
      "name":"sales",
      "description":"Sales Department",
      "components":[
         {
            "componentType":"project",
            "componentId":"component-id-1"
         },
         {
            "componentType":"segment",
            "componentId":"component-id-2"
         }
      ],
      "status":{
         "success":true
      }
   },
   {
      "id":35633,
      "name":"marketing",
      "description":"Marketing Department",
      "components":[
         {
            "componentType":"project",
            "componentId":"component-id-101"
         },
         {
            "componentType":"segment",
            "componentId":"component-id-102"
         }
      ],
      "status":{
         "success":true
      }
   }
]
`}</code></pre>
    <h2 {...{
      "id": "example-deleting-a-tag"
    }}>{`Example deleting a tag`}</h2>
    <p>{`The following request example includes a `}<inlineCode parentName="p">{`curl`}</inlineCode>{` request to delete a tag. It will also un-tag any/all components associated with the tag.`}</p>
    <h3 {...{
      "id": "curl-request-1"
    }}><inlineCode parentName="h3">{`curl`}</inlineCode>{` Request`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`curl -X DELETE \\
  https://cja.adobe.io/componentmetadata/tags/{TAG_ID} \\
  -H 'Accept: application/json' \\
  -H 'Authorization: Bearer {ACCESSTOKEN}' \\
  -H 'Content-Type: application/json' \\
  -H 'x-api-key: {API_KEY}' \\
  -H 'x-gw-ims-org-id: {IMS_ORG_ID}' \\
  -d '{REQUESTJSON}'
`}</code></pre>
    <p>{`The above curl command requests the following:`}</p>
    <ul>
      <li parentName="ul">{`Delete tag with id `}<inlineCode parentName="li">{`TAG_ID`}</inlineCode>{` and its association with other components`}</li>
    </ul>
    <h3 {...{
      "id": "example-response-1"
    }}>{`Example Response`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "tagId": "TAG_ID",
  "status": {
    "success": true
  }
}
`}</code></pre>
    <h2 {...{
      "id": "example-removing-all-tags-from-components"
    }}>{`Example removing all tags from components`}</h2>
    <p>{`The following request example includes a `}<inlineCode parentName="p">{`curl`}</inlineCode>{` request to removes all tags from list of components.`}</p>
    <h3 {...{
      "id": "curl-request-2"
    }}><inlineCode parentName="h3">{`curl`}</inlineCode>{` Request`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`curl -X DELETE \\
  https://cja.adobe.io/componentmetadata/tags?componentIds={COMMA_SEPARATED_COMPONENT_IDS}&componentType={COMPONENT_TYPE} \\
  -H 'Accept: application/json' \\
  -H 'Authorization: Bearer {ACCESSTOKEN}' \\
  -H 'Content-Type: application/json' \\
  -H 'x-api-key: {API_KEY}' \\
  -H 'x-gw-ims-org-id: {IMS_ORG_ID}' \\
  -d '{REQUESTJSON}'
`}</code></pre>
    <p>{`The above curl command requests the following:`}</p>
    <ul>
      <li parentName="ul">{`Removes all tags from list of component ids`}</li>
    </ul>
    <h3 {...{
      "id": "example-response-2"
    }}>{`Example Response`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "id": "{COMMA_SEPARATED_COMPONENT_IDS}",
  "status": {
    "success": true
  }
}
`}</code></pre>
    <h2 {...{
      "id": "example-retrieving-list-of-tags-for-a-company"
    }}>{`Example retrieving list of tags for a company`}</h2>
    <p>{`The following request example includes a `}<inlineCode parentName="p">{`curl`}</inlineCode>{` request to retrieve tags for current company.`}</p>
    <h3 {...{
      "id": "curl-request-3"
    }}><inlineCode parentName="h3">{`curl`}</inlineCode>{` Request`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`curl -X GET \\
  https://cja.adobe.io/componentmetadata/tags?page=0&limit=3 \\
  -H 'Accept: application/json' \\
  -H 'Authorization: Bearer {ACCESSTOKEN}' \\
  -H 'Content-Type: application/json' \\
  -H 'x-api-key: {API_KEY}' \\
  -H 'x-gw-ims-org-id: {IMS_ORG_ID}'
`}</code></pre>
    <p>{`The above curl command requests the following:`}</p>
    <ul>
      <li parentName="ul">{`Retrieve specific page with query param `}<inlineCode parentName="li">{`page`}</inlineCode></li>
      <li parentName="ul">{`Retrieve specific number of tags in a page with query param `}<inlineCode parentName="li">{`limit`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "example-response-3"
    }}>{`Example Response`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "content": [
    {
      "id": 596,
      "name": "sales"
    },
    {
      "id": 597,
      "name": "marketing"
    },
    {
      "id": 662,
      "name": "finance"
    }
  ],
  "numberOfElements": 3,
  "totalElements": 385,
  "totalPages": 129,
  "firstPage": true,
  "lastPage": false,
  "sort": null,
  "size": 3,
  "number": 0
}
`}</code></pre>
    <h2 {...{
      "id": "example-retrieve-tags-for-multiple-components"
    }}>{`Example retrieve tags for multiple components`}</h2>
    <p>{`The following request example includes both a JSON message request body and a `}<inlineCode parentName="p">{`curl`}</inlineCode>{` request to retrieve tags for multiple components.`}</p>
    <h3 {...{
      "id": "json-request-message-1"
    }}>{`JSON Request Message`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json={line-numbers=\"yes\"}"
      }}>{`{
  "componentType": "project",
  "componentIds": [
    "component-id-556"
  ]
}
`}</code></pre>
    <h3 {...{
      "id": "curl-request-4"
    }}><inlineCode parentName="h3">{`curl`}</inlineCode>{` Request`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`curl -X POST \\
  https://cja.adobe.io/componentmetadata/tags/component/search?page=0&limit=3 \\
  -H 'Accept: application/json' \\
  -H 'Authorization: Bearer {ACCESSTOKEN}' \\
  -H 'Content-Type: application/json' \\
  -H 'x-api-key: {API_KEY}' \\
  -H 'x-gw-ims-org-id: {IMS_ORG_ID}' \\
  -d '{REQUESTJSON}'
`}</code></pre>
    <p>{`The JSON message requests the following:`}</p>
    <ul>
      <li parentName="ul">{`Retrieves all tags for component id `}<inlineCode parentName="li">{`component-id-556`}</inlineCode>{` of type project`}</li>
      <li parentName="ul">{`Retrieve specific page with query param `}<inlineCode parentName="li">{`page`}</inlineCode></li>
      <li parentName="ul">{`Retrieve specific number of tags in a page with query param `}<inlineCode parentName="li">{`limit`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "example-response-4"
    }}>{`Example Response`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
"content": [
  {
    "componentType": "project",
    "componentId": "component-id-556",
    "tags": [
      {
        "id": 35625,
        "name": "finance",
        "components": []
      },
      {
        "id": 35624,
        "name": "marketing",
        "components": []
      },      
      {
        "id": 35626,
        "name": "warehouse",
        "components": []
      }
    ]
  }
],
"totalElements": 1,
"totalPages": 1,
"number": 0,
"numberOfElements": 1,
"firstPage": true,
"lastPage": true,
"sort": null,
"size": 10
}
`}</code></pre>
    <h2 {...{
      "id": "example-retrieving-components-using-tags"
    }}>{`Example retrieving components using tags`}</h2>
    <p>{`The following request example includes a `}<inlineCode parentName="p">{`curl`}</inlineCode>{` request to retrieve a components of specific type associated with tag names.`}</p>
    <h4 {...{
      "id": "curl-request-5"
    }}><inlineCode parentName="h4">{`curl`}</inlineCode>{` Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`curl -X GET \\
 https://cja.adobe.io/componentmetadata/tags/tagnames?tagNames={COMMA_SEPARATED_TAG_NAMES}&componentType={COMPONENT_TYPE} \\
  -H 'Accept: application/json' \\
  -H 'Authorization: Bearer {ACCESSTOKEN}' \\
  -H 'Content-Type: application/json' \\
  -H 'x-api-key: {API_KEY}' \\
  -H 'x-gw-ims-org-id: {IMS_ORG_ID}' \\
  -d '{REQUESTJSON}'
`}</code></pre>
    <p>{`The above curl command requests the following:`}</p>
    <ul>
      <li parentName="ul">{`Get components associated with tags present in `}<inlineCode parentName="li">{`COMMA_SEPARATED_TAG_NAMES`}</inlineCode>{`  and of type `}<inlineCode parentName="li">{`COMPONENT_TYPE`}</inlineCode></li>
    </ul>
    <h3 {...{
      "id": "example-response-5"
    }}>{`Example Response`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
  "component-id-1",
  "component-id-2"
]
`}</code></pre>
    <h2 {...{
      "id": "example-retrieving-tag-using-id"
    }}>{`Example retrieving tag using id`}</h2>
    <p>{`The following request example includes a `}<inlineCode parentName="p">{`curl`}</inlineCode>{` request to retrieve a tag with id.`}</p>
    <h4 {...{
      "id": "curl-request-6"
    }}><inlineCode parentName="h4">{`curl`}</inlineCode>{` Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`curl -X GET \\
  https://cja.adobe.io/componentmetadata/tags/{TAG_ID} \\
  -H 'Accept: application/json' \\
  -H 'Authorization: Bearer {ACCESSTOKEN}' \\
  -H 'Content-Type: application/json' \\
  -H 'x-api-key: {API_KEY}' \\
  -H 'x-gw-ims-org-id: {IMS_ORG_ID}' 
`}</code></pre>
    <h3 {...{
      "id": "example-response-6"
    }}>{`Example Response`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "id": 35632,
  "name": "sales",
  "description": "sales department",
  "components": [
    {
      "componentType": "project",
      "componentId": "component-id-1"
    }
  ]
}
`}</code></pre>
    <h2 {...{
      "id": "example-retrieving-tags-for-a-component-of-particular-type"
    }}>{`Example retrieving tags for a component of particular type`}</h2>
    <p>{`The following request example includes a `}<inlineCode parentName="p">{`curl`}</inlineCode>{` request to retrieve tags for a component of particular type.`}</p>
    <h4 {...{
      "id": "curl-request-7"
    }}><inlineCode parentName="h4">{`curl`}</inlineCode>{` Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`curl -X GET \\
  https://cja.adobe.io/componentmetadata/tags/search?componentId={COMPONENT_ID}&componentType={COMPOENT_TYPE} \\
  -H 'Accept: application/json' \\
  -H 'Authorization: Bearer {ACCESSTOKEN}' \\
  -H 'Content-Type: application/json' \\
  -H 'x-api-key: {API_KEY}' \\
  -H 'x-gw-ims-org-id: {IMS_ORG_ID}' 
`}</code></pre>
    <h3 {...{
      "id": "example-response-7"
    }}>{`Example Response`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
  {
    "id": 35653,
    "name": "sales",
    "description": "sales department",
    "components": [
      {
        "componentType": "{COMPONENT_TYPE}",
        "componentId": "{COMPONENT_ID}"
      }
    ]
  },
  {
    "id": 35654,
    "name": "finance",
    "description": "finance department",
    "components": [
      {
        "componentType": "{COMPONENT_TYPE}",
        "componentId": "{COMPONENT_ID}"
      }
    ]
  }
]
`}</code></pre>
    <h2 {...{
      "id": "update-tags-for-components"
    }}>{`Update tags for components`}</h2>
    <p>{`The following request example includes both a JSON message request body and a `}<inlineCode parentName="p">{`curl`}</inlineCode>{` request to create and delete multiple tags associated with components.`}</p>
    <h3 {...{
      "id": "json-request-message-2"
    }}>{`JSON Request Message`}</h3>
    <pre><code parentName="pre" {...{}}>{`[
   {
      "componentType":"project",
      "componentId":"component-id-1",
      "tags":[
         {
            "name":"marketing-1",
            "description":"marketing 1"
         },
         {
            "name":"marketing-2",
            "description":"markerting 2"
         }
      ]
   }
]
`}</code></pre>
    <p>{`The JSON message requests the following:`}</p>
    <ul>
      <li parentName="ul">{`create two tags with description `}<inlineCode parentName="li">{`marketing-1`}</inlineCode>{` and `}<inlineCode parentName="li">{`marketing-2`}</inlineCode></li>
      <li parentName="ul">{`associate `}<inlineCode parentName="li">{`marketing-1`}</inlineCode>{` and `}<inlineCode parentName="li">{`marketing-2`}</inlineCode>{` tag with components with ids `}<inlineCode parentName="li">{`component-id-1`}</inlineCode>{` `}</li>
      <li parentName="ul">{`if there are any preexisting tags associated with `}<inlineCode parentName="li">{`component-id-1`}</inlineCode>{` then remove these associations.`}</li>
    </ul>
    <h4 {...{
      "id": "curl-request-8"
    }}><inlineCode parentName="h4">{`curl`}</inlineCode>{` Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`curl -X PUT \\
  https://cja.adobe.io/componentmetadata/tags/tagitems \\
  -H 'Accept: application/json' \\
  -H 'Authorization: Bearer {ACCESSTOKEN}' \\
  -H 'Content-Type: application/json' \\
  -H 'x-api-key: {API_KEY}' \\
  -H 'x-gw-ims-org-id: {IMS_ORG_ID}' \\
  -d '{REQUESTJSON}'
`}</code></pre>
    <h3 {...{
      "id": "example-response-8"
    }}>{`Example Response`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
  {
    "componentType": "project",
    "componentId": "component-id-1",
    "tags": [
      {
        "id": 35653,
        "name": "marketing-1",
        "description": "marketing 1"
      },
      {
        "id": 35654,
        "name": "marketing-2",
        "description": "marketing 2"
      }
    ],
    "status": {
      "success": true
    }
  }
]
`}</code></pre>
    <h2 {...{
      "id": "api-status-codes"
    }}>{`API status codes`}</h2>
    <p>{`For a description of API status codes and tips for troubleshooting, see the `}<a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-platform/landing/troubleshooting.html#api-status-codes"
      }}>{`Platform FAQ and troubleshooting guide`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      